import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import NotFoundPage from '../views/NotFound.vue';
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: NotFoundPage,
    meta: {
      title: '404'
    }
  },
  {
    path: '/OpenSource',
    name: 'OpenSource',
    component: () => import('../views/OpenSource.vue'),
    meta: {
      title: "开源项目"
    }

  },
  {
    path: '/plan',
    name: 'Plan',
    component: () => import('../views/MaintenancePage.vue'),
    meta: {
      title: "食程计划 - 建设中"
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
